import { createContext } from 'react';

const StoryContext = createContext({
	storyIndex: 0,
	setCurrentStoryIndex: (index: number) => {}
});

export default StoryContext;
